import { FILE_DETAIL_BASE_PATH } from '@/config/baseModulesLink';

export const OfflineFilesLinks = {};

export const QUERY_PARAMS = {
  sendOfflinePhotos: 'damagedId',
};

export const OFFLINE_PATH = {
  offlinePhotosUsers: 'offline-photos-users',
  sendOfflinePhotos: 'send-offline-photos',
};

export const OFFLINE_FILES_LINK = {
  offlinePhotosUsers: (id: number) =>
    `/${FILE_DETAIL_BASE_PATH}/${id}/${OFFLINE_PATH.offlinePhotosUsers}`,
  sendOfflinePhotos: (id: number) =>
    `/${FILE_DETAIL_BASE_PATH}/${id}/${OFFLINE_PATH.sendOfflinePhotos}`,
};
